module.exports = __webpack_public_path__ + "assets/img/mkt-insurance.c63e5282.png";